import { isArray } from '../helpers';

export default {
  props: {
    error: {
      description: 'Error Message If Provided',
      type: [Array, String],
      default: null
    }
  },
  computed: {
    hasError() {
      if (isArray(this.error)) {
        return this.error.length > 0;
      }

      return this.error !== null;
    },

    getError() {
      if (isArray(this.error)) {
        return this.error[0];
      }

      return this.error;
    }
  }
}